/// <amd-module name="Wit/WorkItemGitLinks/Components/PullRequest/PullRequestLinkTarget" />
import * as React from "react";
import { GitPullRequest } from "VC/Common/Contracts/Git";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Icon } from "VSSUI/Icon";
import * as Resources from "Wit/WorkItemGitLinks/Resources";
import { formatBranchName } from "Wit/WorkItemGitLinks/GitLinkUtils";
import { ILinkDisplayData } from "Wit/WorkItemLinksRegistration/Contracts";


export function PullRequestLinkTarget({ link }: { link: ILinkDisplayData }) {
    const pullRequest = link.additionalData?.pullRequest as GitPullRequest | undefined;
    if (!pullRequest?.targetRefName) {
        return <></>;
    }

    return (
        <div className={`inline-flex-row padding-horizontal-4`}>
            <FormatComponent format={Resources.PullRequestInto}>
                <>
                    <Icon iconName="OpenSource" />
                    <span key="target-ref" className="monospaced-xs padding-horizontal-4">
                        {formatBranchName(pullRequest.targetRefName)}
                    </span>
                </>
            </FormatComponent>
        </div>
    );
}
